import React ,{ useEffect, useRef, useState } 
from "react";
import { FormProvider, useForm } from "react-hook-form";

import CpntFormSectionContainer from "../../../components/forms/CpntFormSectionContainer";
import CpntFormSection from "../../../components/forms/CpntFormSection";
import TextInput from "../../../components/forms/TextInput";
import { IFilterNoticeDemande, getDefaultFilterNoticeDemande } from "../../../models/interfaces/IFilterNoticeDemande";
import { typeDemandeNoticeDemandeListNotices, validationMode } from "../../../config/helpers";
import CpntMultiSelect from "../../../components/CpntMultiSelect";
import CpntFilterButtons from "../../../components/CpntFilterButtons";


interface IProps {
  filter?: IFilterNoticeDemande;
  Notice? : boolean;
  changeFilter: (data: IFilterNoticeDemande) => void;
}


//Arrive pas a faire passer unb param au parent...
const NoticesDemandesNoticesFilter: React.FC<IProps> = ({ filter, changeFilter,Notice = true}) => {

  const prevFilterRef = useRef<IFilterNoticeDemande | undefined>(filter);
  const [selectedLibellestypeDemandes, setSelectedLibellestypeDemandes] = useState<any[]>([]);

  useEffect(() => {
    if (JSON.stringify(prevFilterRef.current) !== JSON.stringify(filter) || getValues() !== JSON.stringify(filter)) {
      reset(filter);
    }
    prevFilterRef.current = filter;
  }, [filter]);

  
  const formMethods = useForm<IFilterNoticeDemande>({
    defaultValues: getDefaultFilterNoticeDemande(),
  });

  const { handleSubmit, reset, getValues} = formMethods;

  const handleResetForm = () => {
    localStorage.removeItem("IFilterNoticesDemandesNotices");
    setSelectedLibellestypeDemandes([]);
    changeFilter(getDefaultFilterNoticeDemande());
    reset(getDefaultFilterNoticeDemande()); // Réinitialise explicitement le formulaire
  };

  const handleSubmitForm = () => {
    handleSubmit(onSubmit)();
  };

  const onSubmit = (data: IFilterNoticeDemande) => {
    const typeDemandes = selectedLibellestypeDemandes.map((option: { value: any}) => option.value);
    const combinedData: IFilterNoticeDemande = {
      ...data,
      LibellesTypeDemande: typeDemandes
     };
    changeFilter(combinedData);
    localStorage.setItem("IFilterNoticesDemandesNotices",JSON.stringify(combinedData)); //needed ??
  };


  const handleKeyPress = (e: { key: string; preventDefault: () => void; }) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      //SubmitButton.current.click();
    }
  };
   useEffect(() => {
          if (filter?.LibellesTypeDemande) {
            const SelectedTypeDemandeValues = typeDemandeNoticeDemandeListNotices?.filter((typeDemandeNotice: { Id: any }) =>
              filter?.LibellesTypeDemande?.includes(typeDemandeNotice.Id)
            ) || [];
            const SelectedTypeDemandeValuesList = SelectedTypeDemandeValues?.map((typeDemandeNotice) => {
              return {
                label: typeDemandeNotice.Libelle,
                value: typeDemandeNotice.Id,
              };
            });
            setSelectedLibellestypeDemandes(SelectedTypeDemandeValuesList);
          }
        }, [typeDemandeNoticeDemandeListNotices]);
  return (
    <FormProvider {...formMethods}>
      <form onSubmit={handleSubmit(onSubmit)} onKeyDown={handleKeyPress} >
        <CpntFormSection pSectionLabel="Filtres">
          
          <CpntFormSectionContainer ColumnsSize={12} ColumnsSizesMd={[4, 4, 4,12]}>

              <CpntMultiSelect 
              DefaultLibelle="Sélectionner..."
              options={typeDemandeNoticeDemandeListNotices?.map((tc) => {
                return {
                  Id: tc.Id,
                  Libelle: tc.Libelle,
                };
              })}
              value={selectedLibellestypeDemandes}
              setSelected={setSelectedLibellestypeDemandes}
              label="Type de mise à jour"
              ></CpntMultiSelect>
              <TextInput
              label="EAN"
              formName="Ean"
              validationStyle={validationMode.none}
              placeholder="EAN"
            />
            <div>&nbsp;</div>
             <CpntFilterButtons  
              resetForm={handleResetForm}
              submitForm={handleSubmitForm}
            />
          </CpntFormSectionContainer>
        </CpntFormSection>
      </form>
    </FormProvider>
  );
};

export default NoticesDemandesNoticesFilter;
